import { isEmpty } from 'lodash'

import { ContainerType, getContainerGroupTerm } from '../domain/containerGroupTerms'
import { OverviewItem } from '../domain/overviewItem'

type Key = ContainerType | 'noType'
export const fclOverviewCargoString = (houseCargos: OverviewItem['houseCargos']) => {
  if (houseCargos === undefined || isEmpty(houseCargos)) {
    return '0 x Container'
  }

  const groupedByContainerType = houseCargos.reduce(
    (acc, houseCargo) => {
      const containerType = houseCargo.transportUnitCode ? (houseCargo.transportUnitCode as ContainerType) : 'noType'
      if (!acc[containerType]) {
        acc[containerType] = 0
      }
      acc[containerType] += 1
      return acc
    },
    {} as Record<Key, number>
  )

  return Object.keys(groupedByContainerType)
    .map((containerType) => {
      return 'noType' === containerType
        ? `${groupedByContainerType['noType']} x Container`
        : `${groupedByContainerType[containerType as ContainerType]} x ${getContainerGroupTerm(containerType)}`
    })
    .join(', \n')
}

export const lclOverviewCargoString = (houseCargos: OverviewItem['houseCargos']) => {
  if (houseCargos === undefined || isEmpty(houseCargos)) {
    return '0 x 0.00cbm'
  }

  // Group by cargoItems packageDimensions volumeInCubicMeters
  const groupedByVolumeFromCargoItems = houseCargos
    .map((houseCargo) => {
      const [totalQuantity, totalVolume] = houseCargo.cargoItems.reduce(
        ([quantity, volume], cargoItem) => {
          volume += cargoItem.packageDimensions?.volumeInCubicMeters || 0
          quantity += 1
          return [quantity, volume]
        },
        [0, 0]
      )

      return `${totalQuantity} x ${totalVolume.toFixed(2)}cbm`
    })
    .join(', \n')

  return groupedByVolumeFromCargoItems
}
